module.exports = __webpack_public_path__ + "static/img/09.ae98147.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20250704/09.jpg
// module id = x7H9
// module chunks = 0